import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";

// action types
export const UPDATE_TABLE_STRUCTURE = "getWESCHUTEMAPHISTORYTableStructure";
export const UPDATE_TABLE_DATA = "getWESCHUTEMAPHISTORYTableData";
export const EXPORT_TABLE_DATA = "exportWESCHUTEMAPHISTORYTableData";

// mutation types
export const SET_TABLE_STRUCTURE = "setWESCHUTEMAPHISTORYTableStructure";
export const SET_TABLE_DATA = "setWESCHUTEMAPHISTORYTableData";
export const SET_TABLE_FILTER = "setWESCHUTEMAPHISTORYTableFilter";
export const SET_TABLE_PAGE = "setWESCHUTEMAPHISTORYTablePage";
export const SET_TABLE_PERPAGE = "setWESCHUTEMAPHISTORYTablePerPage";
export const SET_TABLE_SORTBY = "setWESCHUTEMAPHISTORYTableSortBy";
export const SET_TABLE_SORTORDER = "setWESCHUTEMAPHISTORYTableSortOrder";
export const SET_EXPORT_LINK = "setWESCHUTEMAPHISTORYExportLink";

const state = {
  export_link: null,
  table_structure: {},
  table_data: {},
  table_state: {
    page: 1,
    per_page: 50,
    sortBy: "id",
    sortOrder: "desc",
    filters: [],
  },
};

const getters = {
  getWESCHUTEMAPHISTORYTableProperties(state) {
    return state.table_structure.properties;
  },
  getWESCHUTEMAPHISTORYTablePermissions(state) {
    return state.table_structure.permissions;
  },
  getWESCHUTEMAPHISTORYTableState(state) {
    return state.table_state;
  },

  getWESCHUTEMAPHISTORYTableHeaders(state) {
    return state.table_structure.columns;
  },

  getWESCHUTEMAPHISTORYTableFilters(state) {
    return state.table_structure.filters;
  },

  getWESCHUTEMAPHISTORYTableData(state) {
    return state.table_data.data;
  },

  getWESCHUTEMAPHISTORYExportUrl(state) {
    return state.export_link;
  },
  getWESCHUTEMAPHISTORYSUploadType(state) {
    return state.table_structure.type;
  },
};

const actions = {
  [UPDATE_TABLE_STRUCTURE](context) {
    return new Promise((resolve) => {
      ApiService.post("/wes/chuteMappingHistory")
        .then(({ data }) => {
          context.commit(SET_TABLE_STRUCTURE, data);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [UPDATE_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/wes/chuteMappingHistory/datatable", payload)
        .then(({ data }) => {
          context.commit(SET_TABLE_DATA, data);
          resolve(data);

          context.commit(SET_PAGE_LOADING, false);
          setTimeout(() => {
            window.scrollTo(0, 0);
          }, 100);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
  [EXPORT_TABLE_DATA](context, payload) {
    context.commit(SET_PAGE_LOADING, true);
    return new Promise((resolve) => {
      ApiService.post("/wes/chuteMappingHistory/export", payload)
        .then(({ data }) => {
          context.commit(SET_EXPORT_LINK, data.url);
          resolve(data);
        })
        .catch((data) => {
          context.commit(SET_PAGE_LOADING, false);
          resolve(data);
        });
    });
  },
};

const mutations = {
  [SET_TABLE_FILTER](state, filter) {
    state.table_state.filters = filter;
  },
  [SET_TABLE_PAGE](state, page) {
    state.table_state.page = page;
  },
  [SET_TABLE_PERPAGE](state, perPage) {
    state.table_state.per_page = perPage;
  },
  [SET_TABLE_SORTBY](state, sortBy) {
    state.table_state.sortBy = sortBy;
  },
  [SET_TABLE_SORTORDER](state, sortOrder) {
    state.table_state.sortOrder = sortOrder;
  },
  [SET_TABLE_STRUCTURE](state, table_structure) {
    state.table_structure = table_structure.data;
  },
  [SET_TABLE_DATA](state, table_data) {
    state.table_data = table_data;
  },
  [SET_EXPORT_LINK](state, link) {
    state.export_link = link;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
